import auth from "@/middleware/auth";

export default [
    {
        path: "concluir",
        name: "concluir",
        meta: { middleware: [auth] },
        component: () => import("./Concluir")
    }
];
